module.exports = __webpack_public_path__ + "static/img/course_c.928defa2.png";